import { AppShell } from '../components/AppShell';

interface FlowStep {
  n: number;
  title: string;
  role: string;
  location: string;
  color: string;
  icon: React.ReactNode;
}

const FLOW_CHI: FlowStep[] = [
  {
    n: 1, title: 'Lập đề nghị chi (ĐNC)', role: '👤 Người đề nghị', location: 'Thanh toán › Lập đề nghị', color: '#2563EB',
    icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 3v4a1 1 0 0 0 1 1h4" /><path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z" /><path d="M9 9h1M9 13h6M9 17h6" /></svg>),
  },
  {
    n: 2, title: 'NV.KT lập Phiếu chi (PC) → chuyển KTT', role: '👤 NV Kế toán', location: 'Chi tiết ĐNC › Lập PC & chuyển KTT', color: '#16a34a',
    icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 3v4a1 1 0 0 0 1 1h4" /><path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z" /><path d="M9 15h6M12 12v6" /></svg>),
  },
  {
    n: 3, title: 'KTT xét duyệt PC', role: '👤 Kế toán trưởng', location: 'Trung tâm phê duyệt', color: '#f59e0b',
    icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 12 2 2 4-4" /><circle cx="12" cy="12" r="10" /></svg>),
  },
  {
    n: 4, title: 'GĐ (CEO) ký nếu ≥ 3M', role: '👤 Giám đốc', location: 'Trung tâm phê duyệt', color: '#7c3aed',
    icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 8v6M23 11h-6" /><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /></svg>),
  },
  {
    n: 5, title: 'NV.KT xuất tiền + lấy chữ ký người nhận', role: '👤 NV Kế toán', location: 'Chi tiết ĐNC › Xác nhận đã chi', color: '#0ea5e9',
    icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>),
  },
  {
    n: 6, title: 'Lưu chứng từ + vào Sổ quỹ', role: '👤 Tự động', location: 'Sổ quỹ (TM 1111 / TG 1121)', color: '#64748b',
    icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 12V8H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12v4M4 6v12a2 2 0 0 0 2 2h14v-4M18 12h.01" /></svg>),
  },
  {
    n: 7, title: 'Hạch toán → Sổ cái', role: '👤 Tự động', location: 'Sổ cái + Báo cáo', color: '#0f766e',
    icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2zM22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" /></svg>),
  },
];

const ROLES = [
  { key: 'KTT', label: 'KTT · Kế toán trưởng', desc: 'Duyệt phiếu chi + bảng lương · quản lý sổ cái · lập báo cáo', bg: '#eff6ff', border: '#2563EB', color: '#1e3a8a' },
  { key: 'NV_KT', label: 'NV Kế toán', desc: 'Lập phiếu chi + bảng lương · hạch toán · đối chiếu sổ', bg: '#f0fdf4', border: '#16a34a', color: '#14532d' },
  { key: 'CEO', label: 'CEO', desc: 'Ký duyệt cuối bảng lương + PC lớn · xem báo cáo tổng hợp', bg: '#f5f3ff', border: '#7c3aed', color: '#5b21b6' },
  { key: 'NV', label: 'Nhân viên', desc: 'Lập đề nghị chi · xem phiếu lương của mình', bg: '#fef3c7', border: '#f59e0b', color: '#78350f' },
];

const GLOSSARY: Array<[string, string]> = [
  ['PC', 'Phiếu chi (chi tiền mặt)'],
  ['PT', 'Phiếu thu (thu tiền mặt)'],
  ['UNC', 'Uỷ nhiệm chi (chi qua NH)'],
  ['PKT', 'Phiếu kế toán (bút toán tự tạo)'],
  ['BL', 'Bảng lương (payroll)'],
  ['ĐNC', 'Đề nghị chi'],
  ['TNCN', 'Thuế thu nhập cá nhân'],
  ['BHXH', 'Bảo hiểm xã hội'],
  ['BHYT', 'Bảo hiểm y tế'],
  ['BHTN', 'Bảo hiểm thất nghiệp'],
  ['KPCĐ', 'Kinh phí công đoàn'],
  ['LTT', 'Lương tối thiểu vùng'],
  ['NLĐ', 'Người lao động'],
  ['NPT', 'Người phụ thuộc (giảm trừ thuế)'],
  ['NCC', 'Nhà cung cấp'],
  ['QLDN', 'Quản lý doanh nghiệp'],
];

const FAQ: Array<{ q: string; a: React.ReactNode }> = [
  {
    q: 'Vì sao có bước NV.KT lập PC trước khi KTT ký?',
    a: (<>Theo quy trình chi tiền mặt chuẩn (TT200): NV.KT lập <b>Phiếu chi 2 liên</b> từ ĐNC → chuyển KTT ký → chuyển GĐ ký (nếu ≥3M) → NV.KT xuất tiền. Nên KTT + GĐ ký trên <b>PC</b>, không phải ĐNC. Trong hệ thống: <b>Chờ NV.KT lập PC</b> là stage đầu tiên sau khi user submit ĐNC.</>),
  },
  {
    q: 'Khi nào cần CEO/GĐ ký?',
    a: (<>Phiếu chi <b>≥ 3.000.000đ</b> cần CEO/GĐ ký. KTT duyệt PC trước, sau đó phiếu tự chuyển sang <b>Chờ CEO ký</b>. Dưới 3M chỉ cần KTT duyệt.</>),
  },
  {
    q: 'KTT/CEO từ chối thì phiếu đi đâu?',
    a: (<>Từ chối = <b>trả lại stage trước</b> (loop back), không phải hủy. <br />• <b>KTT trả lại</b> → về <i>Chờ NV.KT lập PC</i> để NV.KT sửa PC.<br />• <b>CEO trả lại</b> → về <i>Chờ KTT duyệt</i> để KTT xem lại.<br />Nếu muốn <b>huỷ hẳn</b> phiếu → owner bấm <i>Huỷ</i> ở trạng thái Chờ NV.KT / Chờ KTT.</>),
  },
  {
    q: '"Cần gấp" khác "Bình thường" thế nào?',
    a: (<>Phiếu <b>Cần gấp</b> vào queue <i>Duyệt ngay trong ngày</i> — KTT/CEO xử lý trong 24h. Phiếu <b>Bình thường</b> vào queue <i>Duyệt định kỳ T6</i> — chờ đến thứ 6 hàng tuần duyệt hàng loạt.</>),
  },
  {
    q: 'Tạm ứng "Đột xuất" khác "Có kế hoạch"?',
    a: (<><b>Có kế hoạch</b>: công tác đã duyệt trước, dự án có budget — vào queue batch T6. <b>Đột xuất</b>: sự cố cần chi gấp, hư hỏng, mua vật tư khẩn — vào queue daily (bất kể amount).</>),
  },
  {
    q: 'Tạm ứng &gt; 5M có cần kèm chứng từ không?',
    a: (<>Có. Tạm ứng &gt; 5.000.000đ <b>bắt buộc</b> đính kèm quotation/plan/chứng từ chứng minh mục đích. Không có sẽ bị từ chối tự động ở bước tạo.</>),
  },
  {
    q: 'Thưởng nóng hạch toán thế nào?',
    a: (<><b>Nợ 6421</b> (Chi phí QLDN) / <b>Có 334</b> (Phải trả người lao động). Nếu thưởng chịu TNCN → cộng vào bảng lương kỳ hiện tại để khấu trừ 10% (khi Payroll module go-live).</>),
  },
  {
    q: 'Sổ tiền mặt vs Sổ tiền gửi NH khác gì?',
    a: (<>Sổ tiền mặt (<b>TK 1111</b>) chỉ ghi thu/chi tiền mặt vật lý ở két. Sổ tiền gửi NH (<b>TK 1121</b>) ghi mọi giao dịch qua ngân hàng (UNC, thu KH, chuyển khoản).</>),
  },
  {
    q: 'Ai được duyệt hàng loạt trong bảng?',
    a: (<>KTT/CEO tick chọn các phiếu <i>cùng trạng thái pending phù hợp</i> → thanh action bar hiện Duyệt/Từ chối hàng loạt. NV_KT tick phiếu <i>APPROVED</i> để Xác nhận đã chi hàng loạt.</>),
  },
  {
    q: 'Chứng từ đính kèm lưu ở đâu?',
    a: (<>Upload trực tiếp trong form Lập ĐNC. File lưu trên storage nội bộ (max 10MB · PDF/JPG/PNG/DOCX/XLSX). Chỉ owner, KTT, NV_KT, CEO xem được. Attachment không xoá được sau khi phiếu đã submit.</>),
  },
];

export function GuidePage() {
  return (
    <AppShell title="Hướng dẫn quy trình" subtitle="Sơ đồ nghiệp vụ · Vai trò · Glossary · FAQ">
      <div className="guide-wrap">
        {/* Intro banner */}
        <div className="guide-intro">
          <div className="guide-intro-icon">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><path d="M12 17h.01" /></svg>
          </div>
          <div>
            <h2>Sơ đồ nghiệp vụ kế toán HITEK</h2>
            <p>Xem toàn cảnh luồng chi tiền · vai trò · từ viết tắt · FAQ. Dành cho người mới hoặc lãnh đạo cần xem tổng quan.</p>
          </div>
        </div>

        {/* FLOW 1: Chi tiền */}
        <div className="guide-card">
          <div className="guide-card-head">
            <div className="guide-card-head-left">
              <div className="guide-card-head-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"><path d="m19 12-7 7-7-7M12 5v14" /></svg>
              </div>
              <div>
                <h3>Luồng chi tiền (Đề nghị chi → Sổ cái)</h3>
                <p>7 bước · thời gian trung bình 1-3 ngày</p>
              </div>
            </div>
            <span className="guide-tag">PC · UNC · PT</span>
          </div>
          <div className="guide-flow">
            {FLOW_CHI.map((s, i) => (
              <FlowStep key={s.n} step={s} isLast={i === FLOW_CHI.length - 1} />
            ))}
          </div>
        </div>

        {/* Roles */}
        <div className="guide-card">
          <div className="guide-card-head">
            <div className="guide-card-head-left">
              <div className="guide-card-head-icon" style={{ background: 'linear-gradient(135deg, #7c3aed, #5b21b6)' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
              </div>
              <h3 style={{ margin: 0 }}>Vai trò trong hệ thống</h3>
            </div>
          </div>
          <div className="guide-roles">
            {ROLES.map((r) => (
              <div key={r.key} className="guide-role" style={{ background: r.bg, borderLeftColor: r.border }}>
                <div className="guide-role-label" style={{ color: r.color }}>{r.label}</div>
                <div className="guide-role-desc">{r.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Glossary */}
        <div className="guide-card">
          <div className="guide-card-head">
            <div className="guide-card-head-left">
              <div className="guide-card-head-icon" style={{ background: 'linear-gradient(135deg, #64748b, #334155)' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" /></svg>
              </div>
              <h3 style={{ margin: 0 }}>Glossary — Từ viết tắt hay dùng</h3>
            </div>
          </div>
          <div className="guide-glossary">
            {GLOSSARY.map(([code, meaning]) => (
              <div key={code} className="guide-gloss-row">
                <span className="guide-gloss-code">{code}</span>
                <span className="guide-gloss-mean">{meaning}</span>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ */}
        <div className="guide-card">
          <div className="guide-card-head">
            <div className="guide-card-head-left">
              <div className="guide-card-head-icon" style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><path d="M12 17h.01" /></svg>
              </div>
              <h3 style={{ margin: 0 }}>FAQ — Câu hỏi thường gặp</h3>
            </div>
          </div>
          <div className="guide-faq">
            {FAQ.map((f) => (
              <div key={f.q} className="guide-faq-row">
                <div className="guide-faq-q">{f.q}</div>
                <div className="guide-faq-a">{f.a}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AppShell>
  );
}

function FlowStep({ step, isLast }: { step: FlowStep; isLast: boolean }) {
  return (
    <>
      <div className="guide-flow-step" style={{ borderColor: step.color }}>
        <div className="guide-flow-step-head">
          <div className="guide-flow-step-icon" style={{ background: step.color }}>{step.icon}</div>
          <div className="guide-flow-step-num" style={{ color: step.color, borderColor: step.color }}>{step.n}</div>
        </div>
        <div className="guide-flow-step-title">{step.title}</div>
        <div className="guide-flow-step-role">{step.role}</div>
        <div className="guide-flow-step-loc">{step.location}</div>
      </div>
      {!isLast && (
        <div className="guide-flow-arrow">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
        </div>
      )}
    </>
  );
}
